import { render } from "./HeaderContainer.vue?vue&type=template&id=3ac72c66&scoped=true"
import script from "./HeaderContainer.vue?vue&type=script&lang=js"
export * from "./HeaderContainer.vue?vue&type=script&lang=js"

import "./HeaderContainer.vue?vue&type=style&index=0&id=3ac72c66&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/plus.centrodeglaucoma.com/darmin-plus/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ac72c66"]])

export default __exports__